import type { HTTPService } from "@soft-db/http";

export class AuthApi {
	#http: HTTPService;

	constructor(http: HTTPService) {
		this.#http = http;
	}

	async login(username: string, password: string) {
		return this.#http.post<{ auth_token: string }>("/auth/login", { username, password });
	}

	async loginPublic(token: string) {
		return this.#http.post<{ auth_token: string }>("/auth/login-public", { token });
	}

	async activateAccount(code: string, password: string) {
		const request = await this.#http.withResponseProxy(
			this.#http.post("auth/activate", { code, password })
		);
		return request.status === "SUCCESS";
	}

	async resetPassword(id: string, password: string) {
		return this.#http.post("auth/reset-password", { id, password });
	}

	async resetPasswordRequest(email: string) {
		return this.#http.post("auth/reset-password/request", { email });
	}

	async resetPasswordWithCode(code: string, password: string) {
		const request = await this.#http.withResponseProxy(
			this.#http.post("auth/reset-password/confirm", { code, password })
		);
		return request.status === "SUCCESS";
	}
}
